var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEyeClose(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h18v18H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.412 14.473A8.253 8.253 0 0 1 .886 9 8.237 8.237 0 0 1 3.39 4.45L1.044 2.107l1.061-1.061 14.85 14.85-1.062 1.06-2.482-2.482zm-8.96-8.96A6.724 6.724 0 0 0 2.416 9a6.754 6.754 0 0 0 9.901 4.379l-1.521-1.521a3.375 3.375 0 0 1-4.655-4.655l-1.69-1.69zm5.233 5.233L7.254 8.315a1.875 1.875 0 0 0 2.43 2.43l.002.001zm5.92 1.698-1.073-1.073A6.701 6.701 0 0 0 15.582 9a6.754 6.754 0 0 0-8.418-4.997L5.981 2.82A8.253 8.253 0 0 1 17.114 9a8.21 8.21 0 0 1-1.51 3.444zM8.792 5.631a3.375 3.375 0 0 1 3.577 3.577L8.791 5.63h.001z",
    fill: "#91919C",
    fillRule: "nonzero"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeClose);
export default __webpack_public_path__ + "static/media/eye_close.0c2ece2221e56a4bed93c756dcb0126c.svg";
export { ForwardRef as ReactComponent };